<template>
    <div>
        <div id="multi-select-white" class="with-absolute-button">

            <multi-select id="multi-select-white" class="light-bg" v-model="selectedDocument" label="formattedLabel" track-by="id"
                          open-direction="bottom" :options="documents" :searchable="true" :loading="loading" 
                          :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300" 
                          :max-height="600" :show-no-results="false" :hide-selected="true" :multiple="false" @search-change="getDocuments"
                          @input="documentSelectMultipleChanged" @close="documents = []" :allow-empty="false"
                          ref="multiselect1" :disabled="disabled" :placeholder="$t('res_Label_SelectDocument')">
                <template slot="option" slot-scope="props">
                    <div style="width: 100%; display: flex;text-align:start; ">
                        <div class="ad__box">
                            <p class="ad__text__bold">{{ props.option.subject }} - {{ props.option.referenceNumber }}</p>
                        </div>
                    </div>
                </template>
                <template slot="noOptions" slot-scope="props">
                    <div style="text-align:start">
                        {{ $t("res_Msgs_EmptySearch") }}
                    </div>
                </template>
            </multi-select>
        </div>
    </div>
</template>

<script>
    import constants from '@/assets/js/constants.js'
    import MultiSelect from 'vue-multiselect'
    import axios from 'axios';
    import * as utils from '@/assets/js/common.js'

    export default {
        name: 'DocumentSelector',
        components: { MultiSelect },
        props: {
            //selectedDocument: {type: Object, default: null },
            selectedDocument: { type: Object, default: () => {}},
            disabled: { type: Boolean, default: false },
        },
        data() {
            return {
                loading: false,
                documents: [],
            }
        },
        methods: {
            getDocuments(text) {
                if (text == '')
                    return

                this.loading = true
                axios.get(constants.baseApiUrl + 'Document/SearchDocument?' + 'search=' + text)
                    .then((res) => {
                        if (res && res.data) {
                            res.data.forEach((item) => {
                                item.formattedLabel = item.subject + " - " + item.referenceNumber
                            });
                            this.documents = res.data
                        }
                    })
                    .catch((err) => console.warn(err))
                    .finally(() => this.loading = false)
            },
            documentSelectMultipleChanged(selectedItem) {
                this.$set(this, 'selectedDocument', selectedItem);
                this.$emit('DocumentSelectChange', selectedItem);

                this.documents = [];
            }
        }
    }
</script>

<style scoped>
    #dwt-container {
        display: flex;
        height: inherit;
        width: inherit;
    }

    #dwt-control {
        max-width: 400px;
    }
</style>